import { UiCarouselModel } from "../../models";

export function mockUiCarouselModel({
    id = "carousel-1234",
    type = "uiCarousel",
    locale = "en",
    content = mockUiCarouselModelContent()
}: Partial<UiCarouselModel> = {}): UiCarouselModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiCarouselModelContent = UiCarouselModel["content"];

export function mockUiCarouselModelContent({
    title = "Lorem ipsum",
    arrows = true,
    dots = true,
    ...optionals
}: Partial<UiCarouselModelContent> = {}): UiCarouselModelContent {
    return {
        title,
        arrows,
        dots,
        ...optionals
    };
}
